<template>
<v-container>
  <v-card>
    <v-img
        height="250"
        src="https://source.unsplash.com/MFK0JpFU13U/"
    ></v-img>
    <v-card-title>Find Jobs with an Impact</v-card-title>
    <v-card-text>
      <v-list>
        <v-list-item-group>
          <v-list-item>
            <v-list-item-avatar size="50">
              <img src="https://avatars.githubusercontent.com/u/6154722?s=280&v=4">
            </v-list-item-avatar>
            <v-list-item-content>
              <v-row>
                <v-col>
                  <v-list-item-title>Junior Software Engineer</v-list-item-title>
                  <v-list-item-subtitle><v-icon x-small>mdi-domain</v-icon> Microsoft <v-icon x-small>mdi-map-marker</v-icon> Anywhere</v-list-item-subtitle>
                  <div>
                    <v-chip>Remote</v-chip> <v-chip>Part-time</v-chip>
                  </div>
                </v-col>
                <v-col>
                  <div>
                    <v-chip class="mx-2">Frontend</v-chip>
                    <v-chip class="mx-2">Backend</v-chip>
                    <v-chip class="mx-2">Junior</v-chip>
                  </div>
                </v-col>
                <v-col cols="2" class="text-center">
                  <v-btn color="primary">Apply</v-btn>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-avatar size="50">
              <img src="data:image/png;base64,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">
            </v-list-item-avatar>
            <v-list-item-content>
              <v-row>
                <v-col>
                  <v-list-item-title>Program Manager</v-list-item-title>
                  <v-list-item-subtitle><v-icon x-small>mdi-domain</v-icon> Impact Hub Vienna <v-icon x-small>mdi-map-marker</v-icon> Vienna</v-list-item-subtitle>
                  <div>
                    <v-chip>Remote</v-chip> <v-chip>Impact</v-chip>
                  </div>
                </v-col>
                <v-col>
                  <div>
                    <v-chip class="mx-2">Management</v-chip>
                    <v-chip class="mx-2">Sustainability</v-chip>
                    <v-chip class="mx-2">Team</v-chip>
                  </div>
                </v-col>
                <v-col cols="2" class="text-center">
                  <v-btn color="primary">Apply</v-btn>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card-text>
  </v-card>
</v-container>
</template>

<script>
export default {
  name: "JobBoard"
}
</script>

<style scoped>

</style>